import React from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import {
  useDebouncedCallback,
} from 'use-debounce';
import {
  getStatus as getResourceStatus,
} from 'redux-resource';

import * as actions from 'chronos-actions';
import * as selectors from 'chronos-selectors';

import {
  Sidebar,
} from 'chronos-components';
import {
  calculateSidebarSelection,
} from 'chronos-utils';


const mapState = state => ({
  data: selectors.getSidebarItems(state),
  status: getResourceStatus(state, 'issues.requests.loadingFilterOptions.status', true),
  ...selectors.getUiState([
    'sidebarSearch',
    'sidebarSelection',
    'isSidebarVisible',
    'groupBy',
    'orderBy',
    'orderByType',
    'isGroupByOpen',
  ])(state),
});

const SidebarContainer = () => {
  const state = useSelector(mapState);
  const dispatch = useDispatch();

  const [onSearchChange] = useDebouncedCallback(
    (value) => {
      dispatch(actions.setUiState({ sidebarSearch: value }));
    },
    500,
  );

  return (
    <Sidebar
      data={state.data}
      selected={state.sidebarSelection}
      groupBy={state.groupBy}
      orderBy={state.orderBy}
      orderByType={state.orderByType}
      isGroupByOpen={state.isGroupByOpen}
      setGroupByVisible={(isGroupByOpen) => {
        dispatch(actions.setUiState({ isGroupByOpen }));
      }}
      onGroupBy={(type) => {
        dispatch(actions.setUiState({
          groupBy: type,
          groupByOpen: false,
        }));
      }}
      onOrderBy={(data) => {
        dispatch(actions.setUiState({
          orderBy: data.orderBy,
          orderByType: data.orderByType,
        }));
      }}
      onSelect={id => dispatch(
        actions.setUiState({
          sidebarSelection: calculateSidebarSelection(
            state.sidebarSelection,
            id,
            state.groupBy,
          ),
        }),
      )}
      search={state.sidebarSearch}
      onSearchChange={onSearchChange}
      isSidebarVisible={state.isSidebarVisible}
      setSidebarVisible={(isSidebarVisible) => {
        dispatch(actions.setUiState({ isSidebarVisible }));
      }}
      onClearAllSelectedItems={() => {
        dispatch(actions.clearAllSidebarItems());
      }}
      fetching={state.status.pending}
    />
  );
};

export default SidebarContainer;
